import { InsoleType, ProfileCurveTemplates } from "./Insole";

export class InsoleHighLevelParams {
  profileCurve: ProfileCurveTemplates = ProfileCurveTemplates.Generic;
  length: number;
  width: number;
  thickness: number;
  heelFill: number;
  archFill: number;
  bottomSmoothness: number;
  heelHeight: number;
  highHeelHeight: number = 0;
  heelDepth: number;
  heelWedgeType: string = 'Lateral';
  heelLateralWedge: number;
  heelMedialWedge: number;
  heelFlatness: number;
  heelInsideAngle: number;
  archCenterHeight: number;
  archLateralHeight: number;
  archMedialHeight: number;
  forefootWedgeType: string = 'Free';
  forefootLateralWedge: number = 0;
  forefootMedialWedge: number = 0;
  archSagitalPosition: number = 50;
  bandHeight: number;
  instepArea: number;
  partialLength: number;
  outsoleThickness: number;

  constructor() { }
  loadFromJson(json) {
    this.heelHeight = json.heelHeight;
    this.highHeelHeight = json.highHeelHeight ?? 0;
    this.heelDepth = json.heelDepth;
    this.heelLateralWedge = json.heelLateralWedge;
    this.heelMedialWedge = json.heelMedialWedge;
    this.archCenterHeight = json.archCenterHeight;
    this.archLateralHeight = json.archLateralHeight;
    this.archMedialHeight = json.archMedialHeight;
    this.thickness = json.thickness;
    this.forefootLateralWedge = json.forefootLateralWedge;
    this.forefootMedialWedge = json.forefootMedialWedge;

  }
  toJSON() {
    return {
      heelHeight: this.heelHeight,
      highHeelHeight: this.highHeelHeight,
      heelDepth: this.heelDepth,
      heelLateralWedge: this.heelLateralWedge,
      heelMedialWedge: this.heelMedialWedge,
      archCenterHeight: this.archCenterHeight,
      archLateralHeight: this.archLateralHeight,
      archMedialHeight: this.archMedialHeight,
      thickness: this.thickness,
      forefootLateralWedge: this.forefootLateralWedge,
      forefootMedialWedge: this.forefootMedialWedge
    };
  }

  clone() {
    var newParams = new InsoleHighLevelParams();
    newParams.length = this.length;
    newParams.width = this.width;
    newParams.thickness = this.thickness;
    newParams.heelFill = this.heelFill;
    newParams.archFill = this.archFill;
    newParams.bottomSmoothness = this.bottomSmoothness;
    newParams.heelHeight = this.heelHeight;
    newParams.highHeelHeight = this.highHeelHeight;
    newParams.heelDepth = this.heelDepth;
    newParams.heelWedgeType = this.heelWedgeType;
    newParams.heelLateralWedge = this.heelLateralWedge;
    newParams.heelMedialWedge = this.heelMedialWedge;
    newParams.heelFlatness = this.heelFlatness;
    newParams.heelInsideAngle = this.heelInsideAngle;
    newParams.archCenterHeight = this.archCenterHeight;
    newParams.archLateralHeight = this.archLateralHeight;
    newParams.archMedialHeight = this.archMedialHeight;
    newParams.forefootWedgeType = this.forefootWedgeType;
    newParams.forefootLateralWedge = this.forefootLateralWedge;
    newParams.forefootMedialWedge = this.forefootMedialWedge;
    newParams.profileCurve = this.profileCurve;
    newParams.archSagitalPosition = this.archSagitalPosition;
    newParams.bandHeight = this.bandHeight;
    newParams.instepArea = this.instepArea;
    newParams.outsoleThickness = this.outsoleThickness;
    newParams.partialLength = this.partialLength;
    return newParams;
  }

}
